module.exports = __webpack_public_path__ + "static/media/trashBlue.8b16a70a.svg";